// extracted by mini-css-extract-plugin
export default {"tooltip":"ItemTip__tooltip--GMIr-"};